import { render, staticRenderFns } from "./GasRefinery.vue?vue&type=template&id=44b89ad6"
import script from "./GasRefinery.vue?vue&type=script&lang=js"
export * from "./GasRefinery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports